import React from 'react';
import Pdf from '../Pdf';

function PdfPage() {
  return <Pdf />;
}

export default PdfPage;
